"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.wsClient = 'ws.manager';
exports.wsVs = 'ws.vs';
exports.userChannel = '@user-inbox';
exports.WixArtifactIdHeader = 'x-wix-artifact-id';
exports.DuplexerSocketArtifactId = 'com.wixpress.infra.wix-duplexer-sockets-server';
//# sourceMappingURL=constants.js.map